import * as React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spinner } from "@fluentui/react/lib/Spinner";
import { TooltipHost } from "@fluentui/react";

import { TEXT } from "../../../../../shared/constants/texts";

type InstanceListingProps = {
  data: any;
  idParam: any;
  loadingMsg: any;
  endMsg: any;
  hasMoreData: any;
  loadMoreData: any;
  handleInstanceDnD: any;
  isUploading: any;
  selectedData: any;
};

const InstancesListing: React.FC<InstanceListingProps> = (props) => {
  const { data, idParam, loadingMsg, endMsg, hasMoreData, loadMoreData, handleInstanceDnD, isUploading, selectedData } =
    props;

  const handleDnD = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <React.Fragment>
      <InfiniteScroll
        dataLength={data.length}
        next={loadMoreData}
        hasMore={hasMoreData}
        loader={
          loadingMsg ? (
            <div className="instances-loader-container-is-add-to-ici">
              <Spinner label={loadingMsg} labelPosition="right" />
            </div>
          ) : null
        }
        endMessage={
          endMsg ? (
            <div className="instances-end-message-container-is-add-to-ici">
              <p>{endMsg}</p>
            </div>
          ) : null
        }
        scrollableTarget={idParam}
      >
        {data.map((item) => {
          const name = item.Name || item.ICMAgreementCode;
          let classNameForInstance = "single-instance-container-add-to-ici";
          if (selectedData && selectedData.SysId === item.SysId) {
            classNameForInstance = "single-instance-container-selected-add-to-ici";
          }
          return (
            <React.Fragment key={item.SysId}>
              {!(isUploading && selectedData && selectedData.SysId === item.SysId) ? (
                <div
                  className={classNameForInstance}
                  onDrop={(e) => handleInstanceDnD(e, item)}
                  onDragOver={(e) => handleDnD(e)}
                  onDragEnter={(e) => handleDnD(e)}
                  onDragLeave={(e) => handleDnD(e)}
                >
                  <TooltipHost id="instance-tooltip-add-to-ici" content={name}>
                    <p>{name}</p>
                  </TooltipHost>
                </div>
              ) : (
                <UploadToIci />
              )}
            </React.Fragment>
          );
        })}
      </InfiniteScroll>
    </React.Fragment>
  );
};

const UploadToIci = () => {
  return (
    <div className="instance-uploading-to-ici">
      <Spinner label={TEXT.UPLOADING_TO_ICI} labelPosition="right" />
    </div>
  );
};

export default InstancesListing;
